var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('div',{staticClass:"empty"}),_c('Marquee',{staticClass:"marquee404",attrs:{"data":_vm.marquee_prop}}),_c('div',{staticClass:"spacer"},[_c('router-link',{attrs:{"to":_vm.lang === 'en' ? '/en/' : '/'}},[_vm._v(" Go to Home Page ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }